import Style from './index.module.less';
const BlockTitle = ({ title = '标题', icon = '' }: { title?: string; icon?: string }) => {
  return (
    <div className={Style.wrap}>
      {icon && <img src={icon} alt="" />} <span className={Style.title}>{title}</span>
    </div>
  )
}

export default BlockTitle
